import { DEVICE } from './constants';

export const getWindowDimensions = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

export const deviceEnquire = function(callback: any) {
  const matchDesktop = {
    match: () => {
      callback && callback(DEVICE.DESKTOP);
    },
  };

  const matchLablet = {
    match: () => {
      callback && callback(DEVICE.TABLET);
    },
  };

  const matchMobile = {
    match: () => {
      callback && callback(DEVICE.MOBILE);
    },
  };

  const enquireJs = require('enquire.js');
  enquireJs
    .register('screen and (max-width: 576px)', matchMobile)
    .register(
      'screen and (min-width: 576px) and (max-width: 1199px)',
      matchLablet
    )
    .register('screen and (min-width: 1200px)', matchDesktop);
};
